(() => {
    "use strict"

    console.log('hello')

    if (document.getElementById('sectors')) {
        new Splide('#sectors', {
            arrows: true,
            pagination: false,
            perPage: 2,
            perMove: 1,
            gap: '2rem',
            breakpoints: {
                580: {
                    perPage: 1,
                    gap: '1.5rem'
                }
            }
        })
        .mount()
    }
})()